/**
 * Naive UI locale for the whole app (Hub UI W7.1 — D-12; PO Q10, round 13).
 *
 * The Chinese (Taiwan) locale as is: date pickers, empty states, placeholders and
 * pagination read in Chinese, and every calendar starts on MONDAY (zhTW's
 * `DatePicker.firstDayOfWeek` is 0, which Naive maps to Monday; the English default the
 * app ran on started on Sunday). Nothing is pinned per picker.
 *
 * One change on top: every confirm label reads 「確認」 — the site's confirm word (a
 * dialog's main button only says 確認; the question says what is confirmed) — where zhTW
 * says 「確定」. Controls that pass their own text are unaffected.
 *
 * Not reached: the two discrete APIs (`createDiscreteApi` in useGlobalNotification /
 * useDeliveredEditReason) render outside this provider; they pass their own button text.
 */
import { createLocale, dateZhTW, zhTW } from 'naive-ui';

export const NAIVE_LOCALE = createLocale(
  {
    global: { confirm: '確認' },
    Popconfirm: { positiveText: '確認', negativeText: '取消' },
    DatePicker: { confirm: '確認' },
    TimePicker: { positiveText: '確認' },
    DataTable: { confirm: '確認' },
  },
  zhTW,
);

export const NAIVE_DATE_LOCALE = dateZhTW;
